import { render } from "./ExplorePoster.vue?vue&type=template&id=a48ce108&scoped=true"
import script from "./ExplorePoster.vue?vue&type=script&lang=js"
export * from "./ExplorePoster.vue?vue&type=script&lang=js"

import "./ExplorePoster.vue?vue&type=style&index=0&id=a48ce108&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a48ce108"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QBtn,QBadge});
